var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShow = function SvgIconShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M13.5 12a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "M10 6a6 6 0 0 0-6 6 .75.75 0 0 1-1.5 0 7.5 7.5 0 1 1 15 0 .75.75 0 0 1-1.5 0 6 6 0 0 0-6-6",
    clipRule: "evenodd"
  })));
};
export default SvgIconShow;